/**
 * Circus + castle bundle: 20% off eligible entry lines when the basket includes a circus show ticket.
 *
 * Current Venpos line names (Pirate / BOOM Circus flow) include e.g.:
 *   Circus - Adult, Circus - Child, Circus - Under 3, Circus - Essential Carer
 * Legacy titles (Early Bird Circus…, The Circus, Boom Circus, etc.) also match.
 *
 * Match: name contains "circus", excluding circus workshops only (aligned with
 * BookingContext.calculateCircusDiscountAmount exclusions).
 */
export function ticketNameQualifiesForCircusBundleDiscount(name) {
  const n = (name || '').toLowerCase().trim();
  if (!n.includes('circus')) return false;
  if (n.includes('workshop')) return false;
  return true;
}
